<script>
  import { onMount } from 'svelte'
  import FrictionScore from './FrictionScore.svelte'
  import TitleBlock from './TitleBlock.svelte'
  import ImageBlock from './ImageBlock.svelte'
  import DescriptionBlock from './DescriptionBlock.svelte'
  import SmileSlider from './SmileSlider.svelte'
  import Smiley from './Smiley.svelte'
  import FrictionPoints from './FrictionPoints.svelte'



  //properties

  export let key = null;
  export let title = 'Step Name';
  export let thumb = null;
  export let thumbName = null;
  export let description = 'Step Description';
  export let cs = 50;
  export let fp;
  export let fs;
  export let fpText = '100s clicks something';
  export let averageSatisfaction;
  export let totalFrictionPoints;
  export let totalSteps;
  export let readOnly;

  let fpScore=0;
  let frictionPoints = 0;
  $: fpDifferential = fpScore-frictionPoints;
  

  onMount(() => {
     updateFrictionScore(frictionPoints, cs);
  });

function handleSliderUpdate(event){
  var a = event.detail.cs;

  updateFrictionScore(frictionPoints, a);

}
  function handleFrictionPointUpdate(event){
    var b = event.detail.fp;
    frictionPoints = b;
    updateFrictionScore(b,cs);
  }
  //functions
  function updateFrictionScore(fpoint,cs){
    // console.log(fp+","+cs);
    var ratio = ((cs-50)*-1)/100;
    fpScore = Math.floor((fpoint+(fpoint * ratio)));
    fp = frictionPoints;
    fs = fpScore;

  }

  
</script>

<style>

h3{
  @apply text-xl font-bold  flex items-center space-x-4;
}


</style>
  <div class="border-t-4 border-black">
    <TitleBlock bind:title="{title}"/>
  </div>
<div class="border-t-4 border-b-4 border-black p-0 m-0">
  <ImageBlock bind:thumb="{thumb}" bind:thumbName="{thumbName}" />
</div>

{#if key === 1}
  <div class="border-b-4 border-black py-4 flex items-center" style="grid-column: span {totalSteps};">
    <h3 class="ml-4"><span>Satisfaction</span> </h3>
    
    
    <div class="ml-auto">
      <Smiley size="30px" smile={averageSatisfaction}/>
    </div>
    
    
  </div>
  {/if}


  <div class="border-b">
  <SmileSlider bind:value="{cs}" on:message="{handleSliderUpdate}" key={key}  />
  </div>
  <div class="border-t-4 border-b-4 border-black">
    <DescriptionBlock bind:description="{description}"/>
  </div>

  {#if key === 1}
 <div class="border-b-4 border-black py-4" style="grid-column: span {totalSteps};">
  
  <div class="flex items-center ">
    <h3 class="m-0 ml-4">Friction</h3>
    <div class="ml-auto text-right font-bold text-xl">{totalFrictionPoints}</div>
  </div>
  
  
  
  </div>
  {/if}
  <div class="border-b-4 border-black">
  <FrictionPoints fontSize="1em" key={key} bind:fpText="{fpText}" on:message="{handleFrictionPointUpdate}"/>
</div>
  <!-- <FrictionScore bind:fPoints={frictionPoints} bind:fpScore bind:fp bind:fs bind:fpDifferential /> -->


